<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19CKl5S/tc-custom/9781439660058.jpg?1738411195845" alt="This image is the cover for the book Texas Ingenuity"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Texas Ingenuity
      </h1>
      <p class="bookDescription body article font2">
        <p>Imagination is bigger in Texas, too. This collection of inspiring and often quirky stories highlights dozens of examples of innovation from Lone Star history. The Hamill brothers devised a better oil well to reach gushers at Spindletop. The first Neiman-Marcus store opened in Dallas in 1907, revolutionizing the retail fashion world. Astroturf emerged at the Astrodome in 1966. Fritos and corn dogs are just two ubiquitous snack foods claimed as Texan originals. Houston native, and civil rights activist, Congresswoman Barbara Jordan rose to national prominence as a voice of unity during the Watergate scandal. Author Alan C. Elliott details these and many more lessons in success in Texas Ingenuity.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan C. Elliott
      </h2>
      
      <p class="authorDescription body article">Alan C. Elliott, born and bred in Texas, is the author or co-author of over twenty books, including Currents in American History, Images of America: Oak Cliff and A Daily Dose of the American Dream: Stories of Success, Triumph and Inspiration. He is co-writer with Leon McWhorter of the movie Angels Love Donuts and is the author of several children's books, including the Texas Christmas story Willy the Texas Longhorn. For the latest information, go to www.texasingenuity.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ff646e3